import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="14" height="14" viewBox="0 0 14 14" fill="#F1281B" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.874 1.043a.766.766 0 111.084 1.083L8.083 7l4.875 4.874a.766.766 0 11-1.084 1.083L7 8.084l-4.874 4.874a.766.766 0 01-1.083-1.083L5.917 7 1.043 2.126a.766.766 0 011.083-1.083L7 5.917l4.874-4.874z" fill="current" /></svg>);